
import { Route, RouteProps } from 'react-router';
import AnimatedRedirect from '../AnimatedRedirect';
import { getPendingVerify } from '../../helpers/pendingVerify';

export interface Props extends RouteProps {
  accessibleFor: 'admin' | 'expert' | 'member';
}

export const PrivateRoute: React.FC<Props> = props => {
  // Gate: юзер на этапе verify-email (пройдена регистрация / 403 на login),
  // токена ещё нет — редиректим на страницу подтверждения email.
  const userToken = localStorage.getItem('skillsSurveyUserToken');
  if (getPendingVerify() && !userToken) {
    return <AnimatedRedirect redirectTo='/verify-email' />;
  }

  if (
    (localStorage.getItem('skillsSurveyUserType') === 'is_member' && props.accessibleFor === 'member') ||
    (localStorage.getItem('skillsSurveyUserType') === 'is_expert' && props.accessibleFor === 'expert') ||
    (localStorage.getItem('skillsSurveyUserType') === 'is_moderator' && props.accessibleFor === 'admin')
  ) {
    return <Route {...props} />;
  } else {
    return <AnimatedRedirect redirectTo='/404/' />;
  }
};

export default PrivateRoute;
